"use client"; // Add this directive to mark the file as a client component

import { useEffect, useRef, useState } from 'react';
import { Box, Button, Divider, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { DownloadIcon, Trash } from 'lucide-react';
import { supabase } from "../../../supabaseClient";


const FileUpload = ({ basepath }) => {
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [uploaded, setUploaded] = useState<boolean>(false);
    const [error,setError] = useState<String>();
    const inputRef = useRef<HTMLInputElement>(null);
    const [attachments, setAttachments] = useState([]);
    const fetchFiles = async () => {
        const { data, error } = await supabase.storage
            .from('talentiq')
            .list(basepath)
            console.log(data)
        if (error) {
            console.error('Error fetching files:', error.message);
        }
        else {
            setAttachments(data.map(file => file.name));

        }

    };
    useEffect(() => { fetchFiles(); }, []);


    const handleUpload = async () => {
        if (selectedFile) {
            console.log(selectedFile.name)
            const { data, error } = await supabase.storage
                .from('talentiq')
                .upload(
                    basepath + selectedFile.name,
                    selectedFile
                );

            if (error) {
                console.error('Error uploading file:', error.message);
                setError(error.message);
            } else {
               setUploaded(true);
               fetchFiles();
            }
        }
    };

    const handleDelete = async (filename: string) => {
        console.log( basepath + filename)
        const { data, error } = await supabase.storage.from('talentiq').remove([basepath + filename]);
        if (error) {
            console.error('Error deleting file:', error.message);
        }
        else {
            setAttachments(attachments.filter(file => file !== filename));
        }
    }
    const handleDownload = async (filename: string) => {
        const { data, error } = await supabase.storage.from('talentiq').download(basepath + filename);
        if (data) {
            const url = URL.createObjectURL(data);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', filename); // Get only the filename 
            document.body.appendChild(link); link.click();
            document.body.removeChild(link); URL.revokeObjectURL(url);
        } else {
            console.error('Error fetching download URL');
        }
    }

    return (

        <div>
            <Divider sx={{ my: 2 }} />
            <div className='mb-4'>
                <Typography variant="h6" sx={{ mt: 3, fontWeight: 'bold' }}>
                    Documents
                </Typography>
            </div>

            <input
                type="file"
                ref={inputRef}
                onChange={(e) => {
                    setSelectedFile(e.target.files?.[0] || null);
                    console.log(e.target.files?.[0]);
                    setUploaded(false);
                    setError("");
                }}
            />



            <Box display="flex" justifyContent="space-between" alignItems="flex-start" mt={4}>
                <Box>
                    <Button
                        variant="contained"
                        onClick={handleUpload}
                        sx={{
                            backgroundColor: 'black',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#333',
                            },
                        }}
                    >
                        upload file
                    </Button>
                    {uploaded && <h6 className='text-green-700'>document uploded successfully</h6>}
                    {error && <h6 className='text-red-700'>Unable to upload document.{error}</h6>}

                    <TableContainer className='border mt-4 text-bold w-8'>
                        <Table sx={{ tableLayout: 'fixed' }}>
                            <TableHead>
                                <TableRow><TableCell sx={{ width: '70%', fontFamily: 'Arial, sans-serif', fontSize: '1rem', fontWeight: 'bold' }}>Document Name</TableCell>
                                    <TableCell sx={{ width: '30%', fontFamily: 'Arial, sans-serif', fontSize: '1rem', fontWeight: 'bold' }}>Document Actions</TableCell></TableRow></TableHead>
                            <TableBody>
                                {attachments.map((attachment, index) => (
                                    <TableRow key={index} sx={{ '&:hover': { backgroundColor: '#f5f5f5', cursor: 'pointer' } }} ><TableCell sx={{ width: '100%' }}>{attachment}</TableCell>
                                        <TableCell sx={{ width: '70%' }} ><IconButton onClick={() => handleDelete(attachment)}><Trash /></IconButton>
                                            <IconButton onClick={() => handleDownload(attachment)}> <DownloadIcon /> </IconButton></TableCell>
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </div>
    );
};

export default FileUpload;